import React, { forwardRef } from 'react';
import type { IconProps } from '@phosphor-icons/react';

export const MagnifyingGlassAiIcon = forwardRef<SVGSVGElement, IconProps>(
    function MagnifyingGlassAiIcon(
        {
            className,
            size = 16,
            weight: _weight,
            mirrored: _mirrored,
            ...props
        },
        ref,
    ) {
        return (
            <svg
                ref={ref}
                className={className}
                width={size}
                height={size}
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.75223 8.1724C3.83712 7.94256 4.16156 7.94248 4.24637 8.1724L4.80105 9.67501C4.81692 9.71804 4.84154 9.75781 4.87397 9.79024C4.9063 9.82249 4.94571 9.84733 4.98855 9.86316L6.49376 10.4185C6.72325 10.5035 6.72318 10.8283 6.49376 10.9133L4.99051 11.468C4.9475 11.4838 4.9077 11.5085 4.87527 11.5409C4.84297 11.5732 4.8182 11.6126 4.80236 11.6555L4.24702 13.1607L4.22814 13.201C4.12918 13.3768 3.86937 13.3768 3.77046 13.201L3.75223 13.16L3.19754 11.6568C3.18172 11.6135 3.15656 11.5742 3.12397 11.5415C3.10768 11.5253 3.08989 11.5103 3.07059 11.4979L3.00809 11.468L1.50548 10.9133C1.27554 10.8284 1.27549 10.5033 1.50548 10.4185L3.00809 9.86446C3.0298 9.85654 3.05121 9.84686 3.07059 9.83451L3.12397 9.79089C3.15664 9.75818 3.18172 9.71845 3.19754 9.67501L3.75223 8.1724Z"
                    fill="currentColor"
                />
                <path
                    d="M6.86746 1.48751C8.2843 1.45531 9.6594 1.97076 10.706 2.92631C11.7524 3.88179 12.39 5.20399 12.4866 6.61771C12.5831 8.03156 12.1312 9.42854 11.2242 10.5175L14.3531 13.6464C14.3996 13.6928 14.4367 13.7478 14.4619 13.8085C14.487 13.8691 14.4996 13.9342 14.4996 13.9999C14.4996 14.0655 14.487 14.1306 14.4619 14.1913C14.4367 14.252 14.3996 14.3076 14.3531 14.354C14.3067 14.4004 14.2516 14.437 14.191 14.4621C14.1303 14.4873 14.0653 14.5005 13.9996 14.5005C13.9339 14.5005 13.8689 14.4872 13.8082 14.4621C13.7476 14.437 13.6925 14.4004 13.6461 14.354L10.5172 11.2245C10.0449 11.6178 9.51447 11.9259 8.95014 12.1405C8.69059 12.239 8.41266 12.0786 8.34077 11.8104C8.26996 11.5462 8.42624 11.2766 8.67996 11.1744C8.96587 11.0592 9.24081 10.9143 9.49962 10.7414C10.2396 10.2469 10.8166 9.54413 11.1572 8.72188C11.4977 7.89972 11.5866 6.99506 11.413 6.12227C11.2394 5.24936 10.8106 4.44757 10.1813 3.81824C9.55193 3.18892 8.75012 2.7601 7.87723 2.58646C7.00445 2.41291 6.09976 2.50182 5.27762 2.84232C4.45538 3.18291 3.75255 3.75989 3.25809 4.49988C2.85665 5.10067 2.60728 5.78722 2.52762 6.50053C2.49694 6.77521 2.27536 6.99988 1.99897 6.99988C1.71824 6.99978 1.4903 6.76843 1.52176 6.48946C1.66343 5.23535 2.2164 3.98101 3.09858 3.09883C4.10067 2.09678 5.45068 1.51972 6.86746 1.48751Z"
                    fill="currentColor"
                />
            </svg>
        );
    },
);

MagnifyingGlassAiIcon.displayName = 'MagnifyingGlassAiIcon';
